import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// 3rd party imports
import {
    DxBoxModule,
    DxButtonModule,
    DxChartModule,
    DxDataGridModule,
    DxListModule,
    DxLoadPanelModule,
    DxPopupModule,
    DxSelectBoxModule
} from 'devextreme-angular';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// Component & Interface imports
import { SharedModule } from '../shared-module/shared.module';
import { ManagementCommonModule } from '../management-common/management-common.module';
import { WorkflowModule } from '../workflow/workflow.module';

// Service imports

// Component imports

@NgModule({
    imports: [
        CommonModule,
        DxBoxModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxDataGridModule,
        DxLoadPanelModule,
        DxPopupModule,
        DxListModule,
        DxChartModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        SharedModule,
        ManagementCommonModule,
        WorkflowModule
    ]
})
export class WorkflowDashboardModule {}
